import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from '../assets/img/logo_mir.png';
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon4 from '../assets/img/github.png';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';

import './Style.css';

export const NavBar = () => {

  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

  return (
    <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Brand href="#/">
          <img src={logo} alt="Logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="#/home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
            <Nav.Link href="#/skills" className={activeLink === 'skills' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('skills')}>Skills</Nav.Link>
            <Nav.Link href="#/projects" className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('projects')}>Projects</Nav.Link>
            <Nav.Link href="#/connect" className={activeLink === 'connect' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('connect')}>Contacts</Nav.Link>
            <Nav.Link href="#/ready-made" className={activeLink === 'readymade' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('readymade')}>Readymade Software</Nav.Link>
            {/* <Nav.Link href="#/boimela" className={activeLink === 'boimela' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('boimela')}>Boimela</Nav.Link> */}
            {/* <Nav.Link href="#/solution-provider" className={activeLink === 'solution' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('solution')}>Solution Provider</Nav.Link> */}
           
          </Nav>
          <span className="navbar-text">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/mir-fahim-56b152139/" target="_blank" rel="noopener noreferrer"><img src={navIcon1} alt="" /></a>
              <a href="https://github.com/MIR-FAHIM" target="_blank" rel="noopener noreferrer"><img src={navIcon4} alt="" /></a>
              <a href="https://www.facebook.com/fahim.ridoy/" target="_blank" rel="noopener noreferrer"><img src={navIcon2} alt="" /></a>
              <a href="https://www.instagram.com/mir_ridoy/" target="_blank" rel="noopener noreferrer"><img src={navIcon3} alt="" /></a>
            </div>
            <div>
              <span className="email-label">ridoyfahim92@gmail.com</span>
              <div className="email-label">Email</div>
            </div>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
